import {
  Badge,
  DateRange,
  TheaterComedy,
  WorkOutlined,
} from "@mui/icons-material";
import {
  Card,
  CardMedia,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import VoiceSampleButton from "../elements/voice_sample_button";
import Character from "../models/character";

interface CharacterProfileProps {
  character: Character;
}

export const CharacterProfile: React.FC<CharacterProfileProps> = (props) => {
  const character = props.character;

  return (
    <Stack
      direction={{
        xs: "column",
        md: "row-reverse",
      }}
      spacing={2}
      paddingY={2}
      alignItems={{
        xs: "center",
        md: "start",
      }}
    >
      <>
        {getCharacterSketch()}
        {getCharacterDetails()}
      </>
    </Stack>
  );

  function getCharacterSketch(): React.ReactNode {
    return (
      <Card
        elevation={0}
        style={{
          minWidth: 300,
          width: 300,
          background: character.themeColour ?? "grey",
          color: "white",
          padding: 6,
        }}
      >
        <Box height={400}>
          {character.sketchFile ? (
            <CardMedia
              image={"assets/sketch/" + character.sketchFile}
              style={{ height: 400 }}
            />
          ) : (
            <Typography fontFamily={"monospace"} textAlign="center">
              <br />
              <br />
              Sketch to be added soon
            </Typography>
          )}
        </Box>

        {/* <Typography fontFamily={"cursive"} fontSize={24} fontWeight={"bold"}>
                {character.name}
            </Typography> */}
      </Card>
    );
  }

  function getCharacterDetails(): React.ReactNode {
    return (
      <Box>
        <Box height={12} />
        <Stack direction={"column"} spacing={2}>
          <Stack direction={"row"} spacing={2}>
            <VoiceSampleButton character={character} />
            <Typography
              variant="h5"
              align="left"
              //   textTransform="uppercase"
              fontWeight="bold"
            >
              {character.name}
            </Typography>
          </Stack>

          <Typography
            variant="subtitle1"
            align="left"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {character.synopsis}
          </Typography>

          <Stack direction="row" spacing={2}>
            {character.characteristics.map((characteristic) => (
              <Chip label={characteristic} color="primary" />
            ))}
          </Stack>

          <List>
            <ListItem>
              <ListItemIcon>
                <Tooltip title="Name" placement="left">
                  <Badge color="secondary" />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={character.fullName} />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <Tooltip title="Age" placement="left">
                  <DateRange sx={{ color: "limegreen" }} />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={character.ageGroup} />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <Tooltip title="Profession" placement="left">
                  <WorkOutlined sx={{ color: "deeppink" }} />
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={character.job} />
            </ListItem>

            {character.referenceCharacters && (
              <ListItem>
                <Tooltip title="Reference Characters" placement="left">
                  <ListItemIcon>
                    <TheaterComedy color="info" />
                  </ListItemIcon>
                </Tooltip>
                <ListItemText primary={character.referenceCharacters} />
              </ListItem>
            )}
          </List>
        </Stack>
      </Box>
    );
  }
};
